import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {RULE_TYPES} from '@/constants/workRules';

const state = {
  ruleTypes: RULE_TYPES,
  rules: {},
  rulesByGroup: [],
  searchResults: {},
  ruleViolation: null,
};

export default {
  state,
  actions,
  getters,
  mutations,
};
